import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class PermissionEdit extends Component {
  isChecked() {
    const { response, defaultValue } = this.props;

    if(response !== undefined)
      return response;
    else if(defaultValue !== undefined)
      return defaultValue;
    else
      return false;
  }

  render() {
    const { ariaLabel, id, onChange, disabled } = this.props;

    return (
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        checked={this.isChecked()}
        onChange={e => onChange(e.target.checked)}
        aria-label={ariaLabel} />
    );
  }
}

PermissionEdit.propTypes = {
  ariaLabel: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.bool,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool
};

export default PermissionEdit;
